import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-lfsa-botons-grid',
  templateUrl: './lfsa-botons-grid.component.html',
  styleUrls: ['./lfsa-botons-grid.component.css']
})
export class LfsaBotonsGridComponent implements ICellRendererAngularComp {

  params;
  labelBtn: string;
  classBtn: string;
  iconBtn: string;
  tooltipMensaje: string;
  tooltipOptions: any = {};

  agInit(params): void {
    this.params = params;
    this.labelBtn = this.params.labelBtn || '';
    this.classBtn = this.params.classBtn || 'btn btn-primary btn-block';
    this.iconBtn = this.params.iconBtn || 'fa fa-plus';
    this.tooltipMensaje = this.params.tooltipMensaje || '';
    this.tooltipOptions = this.params.tooltipOptions || {'placement': 'top', 'showDelay': 500};
  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event) {
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node.data
      };
      this.params.onClick(params);
    }
  }

}
